import style from "./GreatDeal.module.scss";
import likeThumb from "../../assets/images/like-thumb.svg";

const GreatDeal = () => {
  return (
    <div className={`${style.greatDeal} flex align-center`}>
      <picture className="flex align-center justify-center">
        <img src={likeThumb} alt="likeThumb" />
      </picture>
      <aside>
        <strong>Great deal</strong>
        <p>
          This is the lowest priced car in Standard category on our website.
        </p>
      </aside>
    </div>
  );
};
export default GreatDeal;
